import React from "react";
import { Col, FormGroup, FormLabel, Row, Tab, Tabs } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import { constants } from "../../../../../utils/Constants";
import ButtonBar from "../../../../core/ButtonBar";
import ComponentHeader from "../../../../core/ComponentHeader/ComponentHeader";
import ProcessComponent from "../../../../core/ProcessComponent";
import SubmitControl from "../../../../core/SubmitControl";
import Table from "../../../../core/Table";

const LifeCycleClassDefinitionDetails = props => {
  const lifeCycleClassDefinition = props.lifeCycleClassDefinition;

  const lifeCyclesTable = lifeCycleClassDefinition => {
    return (
      <>
        <Tabs>
          <Tab eventKey="lifeCycles" title={labels.lifeCycle} className="Tab">
            <Row>
              <Col>
                <Table
                  data={lifeCycleClassDefinition.lifeCycles}
                  columns={props.columns}
                  onTableChange={props.onTableChange}
                  sortable={false}
                  onRowClick={props.onRowClick}
                  selectRow={props.selectRow}
                  node={props.node}
                  onDeleteRow={props.handleOnDelete}
                  onCreateRow={props.handleCreate}
                  showTableHeader
                  tableLabel={labels.states}
                  pageInfo={props.pageInfo}
                  sortInfo={props.sortInfo}
                  paginationOptions={props.paginationOptions}
                />
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </>
    );
  };

  return (
    <>
      <ProcessComponent processes={[constants.OPERATION_ENTITY_ADMINISTRATION]}>
        <div className="container">
          <div className="containerShadow">
            <ComponentHeader
              title={labels.lifeCycleClassDefinition}
              id={lifeCycleClassDefinition.id}
              showBackButton
            />
            <div className="bordered_bottom_rounded">
              <Row>
                <Col sm="2">
                  <FormLabel className="Label">{labels.name}</FormLabel>
                </Col>
                <Col>
                  <FormGroup controlId="name">
                    <SubmitControl
                      autoFocus
                      type="text"
                      title={labels.name}
                      value={lifeCycleClassDefinition.name}
                      onChange={props.onChange}
                      placeholder={labels.name}
                      validationRule={props.validationRules.name}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {lifeCycleClassDefinition.lifeCycles
                ? lifeCyclesTable(lifeCycleClassDefinition)
                : null}
            </div>
            <ButtonBar onSave={props.onSave} disabled={props.disabled} />
          </div>
        </div>
      </ProcessComponent>
    </>
  );
};

export default LifeCycleClassDefinitionDetails;
